<template>
  <div 
    @click="$emit('click')"
    :style="clickable ? 'cursor: pointer;' : ''"
  >
    <div class="picture-img-cover-container">
      <div 
        v-if="showTopRightInfo && content.content_type === 'VIDEO'"
        class="picture-img-cover-container--top-left"
      >
        <strong
          @click.stop="$emit('click-pseudo', content.user)"
          class="video-details--pseudo"
        >
          @{{ content.user_pseudo }}
        </strong>
        <br>
        <span v-if="content.categories" class="text-muted">
          <template v-for="(category, index) in content.categories">
            <span
              class="video-details--category"  
              :key="`content-category-${index}`"
              @click.stop="$emit('click-category', category)"
            >
              {{ category }}
            </span>
            <span :key="index" v-if="index < content.categories.length - 1">, </span>
          </template>
        </span>
      </div>

      <div 
        v-if="showTopRightInfo && content.content_type === 'AIRCRAFT_ACCIDENT'"
        class="picture-img-cover-container--top-left"
      >
        <strong class="video-details--pseudo">
          {{ $t('content_item.accident_report') }}
        </strong>
        <br>
        <span class="text-muted">
          {{ content.reporting_organization }}
        </span>
      </div>

      <figure>
        <img 
          v-if="content.content_type === 'VIDEO' && content.image_cover"
          :src="displayImageWithObjectUrl(content.image_cover)" 
          class="picture-img-cover"  
          :alt="$t('content_item.video_cover_alt')"
          style="width: 100%;"
        />
        <img 
          v-else-if="content.content_type === 'AIRCRAFT_ACCIDENT'"
          :src="require('@/assets/images/learn/learning_rapports_accidents.webp')" 
          class="picture-img-cover"  
          :alt="$t('content_item.accident_report_alt')"
          style="width: 100%;"
        />
        <img 
          v-else
          :src="require('@/assets/images/video/cover_default.png')" 
          class="picture-img-cover"  
          :alt="$t('content_item.default_cover_alt')"
          style="width: 100%;"
        />
      </figure>

      <div
        v-if="showLikeButton"
        class="picture-img-cover-container--top-right-like"
      >
        <img
          @click.stop="$emit('like', content)"
          :src="likeImage"
          class="video-item-picture--like"
          width="40px"
          :alt="$t('content_item.like_icon_alt')"
        />
      </div>
    </div>

    <div class="video-details mt-2">
      <div>
        <strong v-if="content.content_type === 'VIDEO'">{{ content.title }}</strong>
        <strong v-else>
          {{content.manufacturer}} {{ content.aircraft_type }}
          <template v-if="content.location && content.location !== 'Unknown'">
            | {{ content.location }}
          </template>
        </strong>
        <br>
        <span 
          class="text-muted"
          style="font-size:0.8em;"  
        > 
          <template v-if="content.content_type === 'VIDEO'">
            {{ $t('content_item.last_update', { date: $dayjs(content.updated_at).format('DD/MM/YYYY') }) }}
          </template>
          <template v-else>
            {{ content.created_at ? $t('content_item.published_date', { date: $dayjs(content.created_at).format('DD/MM/YYYY') }) : $t('content_item.published_date_na') }}
          </template>
        </span>
      </div>
      <div
        v-if="content.content_type === 'VIDEO' && content.video_access_option !== 'FREE'"
        class="video-details--price"
      >
        <span v-if="content.video_access_option === 'PAY_PER_VIEW'">
          {{ content.price }} $
        </span>
        <span v-if="content.video_access_option === 'INCLUDED_IN_SUBSCRIPTION'">
          {{ $t('content_item.subscription') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentItem',
  props: {
    content: {
      type: Object,
      required: true
    },
    showTopRightInfo: {
      type: Boolean,
      default: true
    },
    showLikeButton: {
      type: Boolean,
      default: true
    },
    clickable: {
      type: Boolean,
      default: true
    },
    userId: {
      type: Number,
      default: null
    }
  },
  computed: {
    likeImage() {
      if (!this.userId) {
        return require('@/assets/images/newsletter/like_icon.svg')
      }
      return this.content.likes && this.content.likes.includes(Number(this.userId))
        ? require('@/assets/images/newsletter/like_icon_full.svg')
        : require('@/assets/images/newsletter/like_icon.svg')
    }
  },
  methods: {
    displayImageWithObjectUrl(file) {
      if (typeof file === 'string') {
        return file
      }
      return URL.createObjectURL(file)
    }
  }
}
</script>

<style scoped>
.picture-img-cover-container {
  padding-left: 15px;
  padding-right: 15px;
  position: relative;
}

.picture-img-cover {
  margin-left: auto;
  margin-right: auto;
  aspect-ratio: 16 / 9;
  display: block;
  width: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 10px;
}

.picture-img-cover-container--top-right {
  position: absolute;
  top: 10px;
  right: 25px;
}

.picture-img-cover-container--top-left {
  position: absolute;
  top: 10px;
  left: 25px;
}

.picture-img-cover-container--top-right-like {
  position: absolute;
  top: 5px;
  right: 20px;
}

.picture-img-cover-container--bottom-right {
  position: absolute;
  bottom: 10px;
  right: 25px;
}

.video-details {
  display: flex;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
}

.video-item-picture--like {
  cursor: pointer;
}

.video-details--pseudo {
  cursor: pointer;
}

.video-details--category {
  cursor: pointer;
}

.video-details--price {
  font-weight: bold;
  border: solid 1px black;
  padding: 10px;
  border-radius: 10px;
  min-width: 70px;
  text-align: center;
}
</style>
